import { useAuth as useAuthFromContext } from '../context/AuthContext';

/**
 * Hook to access authentication context
 * @returns {Object} Auth context with user, isAuthenticated, login, logout, etc.
 */
export const useAuth = () => {
  return useAuthFromContext();
};

export default useAuth;
